// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ensv1","largestCol":"styles_largestCol__1DSgk","smallestCol":"styles_smallestCol__1Bia1"};